/** Преобразовать число к строке
 * Знак сохраняется
 * Если число меньше 10, то после знака добавляется 0
 * @param {number} count Преобразуемое число
 * @returns {string}
 *  */

export const zeroPadding = (count: number): string => {
  const absoluteCount = Math.abs(count);

  const minus = count < 0 ? '-' : '';

  const zero = absoluteCount < 10 ? '0' : '';

  return `${minus}${zero}${absoluteCount}`;
};
